<template>
  <div>
    <a-alert banner message="设备处于低功耗运行状态，除【关阀】外的其他指令非即时生效。" />
    <a-alert banner message="无法下发操作命令" style="margin: 5px 0;" type="error" v-show="!model.hubcode" />
    <a-tabs>
      <a-tab-pane key="exec-command" tab="设备动作">
        <a-row>
          <a-col :key="id" span="12" v-for="(cmd, id) in commands">
            <a-card :hoverable="true" :title="cmd.commandName" size="small">
              <a-button @click="execCommand(cmd)" size="small" slot="extra" type="primary">立即执行</a-button>
              <a-checkbox-group v-if="cmd.wfDevControlCmdparamList.length > 0" v-model="checkedCmdParam[cmd.id]">
                <a-checkbox
                  :key="cp.id"
                  :value="cp.paramValue"
                  v-for="cp in cmd.wfDevControlCmdparamList"
                >{{ cp.paramName }}</a-checkbox>
              </a-checkbox-group>
            </a-card>
          </a-col>
        </a-row>
      </a-tab-pane>
      <a-tab-pane key="set-value" tab="数值设定">
        <a-row :gutter="[8, 16]">
          <a-col :key="id" span="12" v-for="(point, id) in points">
            <a-button :disabled="!!point.readonly" @click="setValue(point)" class="edit-btn">
              <span>{{point.shortName || point.pointName}}</span>

              <span v-if="!!point.timeSeriesDetail">
                {{point.timeSeriesDetail.value}}
                <a-icon type="form" />
              </span>
            </a-button>
          </a-col>
        </a-row>
      </a-tab-pane>
      <a-tab-pane key="param-set" tab="参数下发">
        <a-row :gutter="[8, 16]">
          <a-col :key="id" span="12" v-for="(p, id) in params">
            <a-card :hoverable="true" :title="p.paramName" @click="setParam(p)" size="small">
              <h1 style="font-weight: bold;">{{p.paramDesc}}</h1>
              <p>{{`${p.paramCode}=${p.defaultValue}`}}</p>
            </a-card>
          </a-col>
        </a-row>
      </a-tab-pane>
      <a-tab-pane key="sys-update" tab="程序升级">
        <j-form-container>
          <a-form-model
            :model="updateProgramModel"
            :rules="updateProgramValidatorRules"
            @keyup.enter.native="execSysUpdate"
            ref="updateProgramForm"
            slot="detail"
          >
            <a-row>
              <a-col :span="24">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="版本号" prop="version">
                  <a-input placeholder="请输入版本号" v-model="updateProgramModel.version"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="24">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="下载地址" prop="url">
                  <a-input placeholder="请输入下载地址" v-model="updateProgramModel.url"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="24" style="display: flex;">
                <a-button @click="execSysUpdate" icon="to-top" style="margin: auto;" type="primary" v-has="'dev:set'">下发</a-button>
              </a-col>
            </a-row>
          </a-form-model>
        </j-form-container>
      </a-tab-pane>
    </a-tabs>

    <a-modal
      :title="setValuePoint.pointName"
      :visible="showSetValueModal && !!setValuePoint"
      @cancel="showSetValueModal = false"
      @ok="execSetValue"
      okText="下发"
    >
      <a-row :gutter="24" @keyup.enter.native="execSetValue">
        <a-col :span="24">
          <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="设置值" prop="value">
            <a-input-number placeholder="请输入设置值" style="width: 100%" v-model="setValuePoint.value" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-modal>

    <a-modal
      :title="setParamProp.paramName"
      :visible="showSetParamModal"
      @cancel="showSetParamModal = false"
      @ok="execSetParam"
      okText="下发"
    >
      <a-row :gutter="24" @keyup.enter.native="execSetParam">
        <a-col :span="24">
          <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="设置参数值" prop="defaultValue">
            <a-textarea :rows="4" placeholder="请输入参数值" style="width: 100%" v-model="setParamProp.defaultValue" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-modal>
  </div>
</template>

<script>
  import { postAction, getAction } from '@/api/manage'

  export default {
    name: 'DeviceControlForm',
    components: {

    },
    data () {
      return {
        model: {
            hubcode: null
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        commands: {},
        checkedCmdParam: {},
        points: {},
        showSetValueModal: false,
        setValuePoint: {},
        params: {},
        showSetParamModal: false,
        setParamProp: {},
        updateProgramModel: {},
        updateProgramValidatorRules: {
          version: [
            { required: true, message: '请输入版本号!' },
          ],
          url: [
            { required: true, message: '请输入下载地址!' },
          ],
        },
        url: {
          getCommand: '/wf/controlCmd/listAll',
          getPoint: '/monitor/iotModelPoints/list',
          getParam: '/device/devParam/list',
          getBleConfig: '/wf/BLEConfig/list',
          addMsg: '/wf/publishMsg/add',
          devClass: '/device/devClass/selectDropList'
        }
      }
    },
    methods: {
      edit (record) {
        this.model = Object.assign({hubcode: null}, record)

        this.getBleConfig()
        this.getCommands()
        this.getPoints()
        this.getParams()
        this.visible = true
      },
      getBleConfig () {
        getAction(this.url.getBleConfig, { devId: this.model.id }).then(res => {
          if (res.success && res.result && res.result.records[0]) {
            this.model.hubcode = res.result.records[0].deviceId.replace(/:/g, '');
            console.log(this.model);
            
          }else{
            this.$message.warning('未查询到设备关联的通信网关，命令将无法下发，请先关联配置测点')
          }
        })
      },
      getCommands () {
        getAction(this.url.getCommand).then(res => {
          res.result.forEach(item => {
            this.$set(this.commands, item.id, item);
          })
        })
      },
      getPoints () {
        getAction(this.url.getPoint, { devId: this.model.id, pageSize: 9999 }).then(res => {
          res.result.records.forEach(item => {
            this.$set(this.points, item.id, item);
          })
        })
      },
      getParams () {
        getAction(this.url.getParam, { devId: this.model.id, pageSize: 9999, configurable: 1 }).then(res => {
          res.result.records.forEach(item => {
            this.$set(this.params, item.id, item);
          })
        })
      },
      execCommand (cmd) {
        const cmdParam = this.checkedCmdParam[cmd.id];
        if (cmd.wfDevControlCmdparamList.length) {
          if (!cmdParam || !cmdParam.length) {
            this.$message.warning('请选择参数');
            return;
          }
        }
        const dataStr = JSON.stringify({
          command: cmd.command,
          param: cmdParam || []
        });
        const param = {
          bizType: "exec-command",
          devId: this.model.id,
          hubcode: this.model.hubcode,
          payloadData: dataStr
        }
        this.saveMsg(param);
      },
      setValue (point) {
        this.setValuePoint = point;
        this.showSetValueModal = true;
      },
      execSetValue () {
        if (typeof this.setValuePoint.value === 'undefined') {
          this.$message.warning('请输入设置值');
          return
        }
        const pointId = this.setValuePoint.pointCode.substring(this.setValuePoint.pointCode.lastIndexOf('_P_') + 3);
        const dataStr = JSON.stringify({
          id: pointId,
          value: this.setValuePoint.value
        });
        const param = {
          bizType: "set-value",
          devId: this.model.id,
          hubcode: this.model.hubcode,
          payloadData: dataStr
        }
        this.saveMsg(param, () => {
          this.showSetValueModal = false;
        });
      },
      setParam (param) {
        this.setParamProp = param;
        this.showSetParamModal = true;
      },
      execSetParam () {
        if (!this.setParamProp.defaultValue) {
          this.$message.warning('请输入参数值');
          return
        }
        const dataStr = JSON.stringify({
          param: this.setParamProp.paramCode,
          value: this.setParamProp.defaultValue
        });
        const param = {
          bizType: "param-set",
          devId: this.model.id,
          hubcode: this.model.hubcode,
          payloadData: dataStr
        }
        this.saveMsg(param, () => {
          this.showSetParamModal = false;
        });
      },
      execSysUpdate () {
        this.$refs.updateProgramForm.validate(valid => {
          if (valid) {
            const dataStr = JSON.stringify(this.updateProgramModel);
            const param = {
              bizType: "sys-update",
              devId: this.model.id,
              hubcode: this.model.hubcode,
              payloadData: dataStr
            }
            this.saveMsg(param);
          }
        })
      },
      saveMsg (param, fn) {
        if (!param.hubcode) {
          this.$message.warning('未查询到设备关联的通信网关，命令将无法下发，请先关联配置测点')
          return;
        }
        postAction(this.url.addMsg, param).then(res => {
          if (res.success) {
            this.$message.success('命令已生成，等待执行');
            fn && fn();
          } else {
            this.$message.warning(`命令生成失败: ${res.message}`);
          }
        })
      },
      getModalAsContainer (node) {
        return document.querySelector('.j-modal-box .ant-modal-content')
      }
    }
  }
</script>
<style scoped>

  .edit-btn {
    width: 260px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: auto;
  }

</style>
